module.exports = __webpack_public_path__ + "static/img/manage.9d17045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/manage.png
// module id = DLAp
// module chunks = 0